export const PROGRESS_STEP = {
  ON_OPEN_DIALOG: 'ON_OPEN_DIALOG',
  ON_SELECT_INVOICE: 'ON_SELECT_INVOICE',
  ON_OPEN_DRAWER: 'ON_OPEN_DRAWER',
} as const;
